"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Item = void 0;
var _link = _interopRequireDefault(require("@clayui/link"));
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireDefault(require("react"));
var _excluded = ["as", "active", "children", "disabled", "href"];
/**
 * SPDX-FileCopyrightText: © 2019 Liferay, Inc. <https://liferay.com>
 * SPDX-License-Identifier: BSD-3-Clause
 */
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) { o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } } return t; }
var Item = exports.Item = function Item(_ref) {
  var _ref$as = _ref.as,
    As = _ref$as === void 0 ? _link.default : _ref$as,
    _ref$active = _ref.active,
    active = _ref$active === void 0 ? false : _ref$active,
    children = _ref.children,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    href = _ref.href,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("li", {
    className: (0, _classnames.default)('page-item', {
      active: active,
      disabled: disabled
    })
  }, As === 'div' ? /*#__PURE__*/_react.default.createElement(As, _extends({}, otherProps, {
    className: "page-link"
  }), children) : /*#__PURE__*/_react.default.createElement(As, _extends({}, otherProps, {
    "aria-current": active && href ? 'page' : undefined,
    className: "page-link",
    href: disabled || active ? undefined : href,
    onClick: function onClick(event) {
      if (!href) {
        event.preventDefault();
      }
      if (otherProps.onClick) {
        otherProps.onClick(event);
      }
    },
    tabIndex: active || !href && !disabled ? 0 : undefined
  }), children));
};